/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, December 2021
 * @format
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classes from './CheckCard.module.css';

const Divider = props => {
  return (
    <div className={classes.dividerContainer}>
      <span>{props.title}</span>
    </div>
  );
};

Divider.propTypes = {
  title: PropTypes.string.isRequired,
};

Divider.defaultProps = {
  title: '',
};

const NoChecks = () => {
  return (
    <div className={classes.noChecks}>
      <span> No checks available</span>
    </div>
  );
};

export { Divider, NoChecks };
